<template>
  <b-row align-h="center" v-if="dataLoading" class="mt-2">
    <b-spinner style="width: 4rem; height: 4rem" type="grow" variant="primary" :label="$t('Spinning')"></b-spinner>
  </b-row>
  <div v-else>
    <b-sidebar id="sidebar-right" ref="mySidebar" bg-variant="white" v-model="visibility" sidebar-class="sidebar-lg" right no-header backdrop shadow>
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ $t("Projects") }}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hideSideBar()" />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group :label="$t('Project Name')" :invalid-feedback="$t('Project name is required')">
              <b-form-input ref="dep_name" v-model="depObj.name" :placeholder="$t('Enter project name')" @focusout="CheckName()">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button variant="success" class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0" @click="addDep()" :disabled="saving">
              <b-spinner v-if="saving" small type="grow" />
              <feather-icon v-else :icon="accIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table class="mt-1" show-empty :items="depList" :fields="depFields" responsive hover small>
          <template #head()="scope">
            <div :class="scope.label == 'actions' && 'text-right'">
              {{ $t(scope.label) }}
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button variant="primary" class="btn-icon mr-50" @click="Edit(data.item)">
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button variant="outline-danger" class="btn-icon" @click="Delete(data.item.id)">
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar id="sidebar-right" ref="mySidebarVendor" bg-variant="white" v-model="visibilityVendor" sidebar-class="sidebar-lg" right width="500" no-header
      backdrop shadow>
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ $t("Vendors") }}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hideSideBarVendor()" />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group :label="$t('Vendor Name')" :invalid-feedback="$t('Vendor name is required')">
              <b-form-input ref="vendor_name" class="mb-50" v-model="vendorObj.name" :placeholder="$t('Enter vendor name')" @focusout="CheckVendorName()">
              </b-form-input>
              <b-form-input ref="vendor_mobile" v-model="vendorObj.mobile_number" :placeholder="$t('Enter mobile no')">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button variant="success" class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0" @click="addVendor()" :disabled="saving">
              <b-spinner v-if="saving" small type="grow" />
              <feather-icon v-else :icon="accIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table class="mt-1" show-empty :items="vendorList" :fields="vendorFields" responsive hover small>
          <template #head()="scope">
            <div :class="scope.label == 'actions' && 'text-right'">
              {{ $t(scope.label) }}
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button variant="primary" class="btn-icon mr-50" @click="EditVendor(data.item)">
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button variant="outline-danger" class="btn-icon" @click="DeleteVendor(data.item.id)">
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar id="sidebar-right" ref="mySidebar" bg-variant="white" v-model="visibility2" sidebar-class="sidebar-lg" right width="600" no-header backdrop
      shadow>
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ $t("Voucher Settings") }}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="visibility2 = false" />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12" v-for="(item, ind) in vtSaveData" :key="ind">
            <b-form-group :label="$t(item.voucherType)" :invalid-feedback="$t('Account is required')">
              <v-select :ref="'account' + ind" :filterBy="dropFilter" v-model="item.accountID" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="accList" :reduce="(opt) => opt.id" label="title" :clearable="true" :placeholder="$t('Select account')" class="account-select">
                <template #option="option">
                  <div class="account-option" v-b-tooltip.hover.top :title="`${option.title} (${option.code})`">
                    <div class="account-name">{{ option.title }}</div>
                    <div class="account-code">{{ option.code }}</div>
                  </div>
                </template>
                <template #selected-option="option">
                  <div class="account-selected">
                    <div class="account-name-text">{{ option.title }}</div>
                    <div class="account-code-text">{{ option.code }}</div>
                  </div>
                </template>
              </v-select>
              <!-- @input="testing(item)" -->
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button variant="success" @click="saveVtSettings()" :disabled="saving" block>
              <b-spinner v-if="saving" small type="grow" />
              <span v-else>{{$t('Save')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-modal id="modal-grn" :title="$t('Goods Receiving Note')" centered size="lg">
      <b-table :items="supplierGrns" :fields="grnFields" responsive show-empty selectable select-mode="multi" @row-selected="selectGrn">
        <template #head()="scope">
          {{ $t(scope.label) }}
        </template>
        <template #cell(id)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(quotationID)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.value).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>
        <template #cell(total)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(deliveryCharges)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(note)="data">
          {{ data.value }}
        </template>
      </b-table>

      <template #modal-footer>
        <b-button variant="success" class="btn-icon" :disabled="selectedList.length == 0" @click="confirmGrn()">
          <span class="align-middle">{{ $t("Confirm") }}</span>
        </b-button>
      </template>
    </b-modal>

    <b-row>
      <h3 class="mb-1 col-md-6">
        <b-button variant="outline-secondary" class="btn-icon rounded-circle mr-50" @click="$router.go(-1)">
          <feather-icon icon="ArrowLeftIcon" size="16" />
        </b-button>
        {{ $t("Journal Entry") }}
      </h3>

      <template v-if="saveObj.id == 0 && accObj && accObj.valueBool">
        <b-input-group class="col-md-3 round p-0 mb-50">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>

          <b-form-input v-model.trim="searchID" :placeholder="$t('Enter GRN ID here')" :disabled="poLoading" @keyup.enter="checkGrnID()">
          </b-form-input>
        </b-input-group>
        <b-col md="3" class="mb-50">
          <v-select v-model="supplierObj" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="supplierList" label="name" :placeholder="$t('Select vendor')"
            clearable :disabled="poLoading" class="bg-white" @input="getGrn()" />
        </b-col>
      </template>
    </b-row>
    <b-card>
      <b-row>
        <b-col md="2">
          <!-- label="Voucher Type" -->
          <b-form-group :invalid-feedback="$t('Voucher Type is required')" ref="vt">
            <div class="d-flex justify-content-between pb-50">
              <label class="bv-no-focus-ring col-form-label p-0">{{ $t("Voucher Type") }}</label>
              <feather-icon icon="SettingsIcon" size="18" class="cursor-pointer" v-b-tooltip.hover.top :title="$t('Settings')" @click="openVtSettings()" />
            </div>
            <v-select v-model="saveObj.voucherType" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="typeOptions" :reduce="(opt) => opt.text"
              label="text" :clearable="false" ref="vt" :placeholder="$t('Select type')" @input="setVT()" />
          </b-form-group>
        </b-col>
        <b-col md="2" v-if="saveObj.id > 0">
          <b-form-group :label="$t('Voucher Number')" :invalid-feedback="$t('Voucher Number required')">
            <b-form-input type="number" disabled :placeholder="$t('Enter Voucher No')" v-model="saveObj.voucherNum" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('Date')" :invalid-feedback="$t('Date is required')" ref="date">
            <flat-pickr :config="config" ref="date" v-model="saveObj.date" class="form-control" :placeholder="$t('Select date')" :disabled="rights.disableDate" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group :label="$t('Cheque Title')" :invalid-feedback="$t('Cheque Title required')" ref="chTitle">
            <b-form-input ref="chTitle" :placeholder="$t('Enter cheque title')" v-model="saveObj.chequeTitle" />
          </b-form-group>
        </b-col>
        <b-col md="3" v-if="multiDep && multiDep.valueBool">
          <b-form-group :invalid-feedback="$t('Project is required')" ref="dep">
            <div class="d-flex">
              <label class="bv-no-focus-ring col-form-label pt-0">{{ $t("Project") }}</label>
              <feather-icon class="cursor-pointer ml-50" icon="EditIcon" size="18" v-b-tooltip.hover.top :title="$t('Manage Projects')" @click="openDep()" />
            </div>
            <v-select v-model="saveObj.departmentID" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="depList" :reduce="(opt) => opt.id"
              label="name" :clearable="false" ref="dep" :placeholder="$t('Select project')" />
          </b-form-group>
        </b-col>
        <b-col md="2" v-if="multiDep && multiDep.valueBool">
          <b-form-group :invalid-feedback="$t('Vendor is required')" ref="vendor">
            <div class="d-flex">
              <label class="bv-no-focus-ring col-form-label pt-0">{{ $t("Vendor") }}</label>
              <feather-icon class="cursor-pointer ml-50" icon="EditIcon" size="18" v-b-tooltip.hover.top :title="$t('Manage Vendors')" @click="openVendor()" />
            </div>
            <v-select v-model="saveObj.vendorID" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="[{ id: 0, name: $t('None') }, ...vendorList]"
              :reduce="(opt) => opt.id" label="name" :clearable="false" ref="vendor" :placeholder="$t('Select Vendor')" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-0">
      <b-row v-for="(item, ind) in myObj" :key="ind" class="mb-1 mb-md-0">
        <!-- style="display: flex; align-items: center" -->
        <b-col md="3" class="pr-1 pr-md-0 account-col">
          <b-form-group :label="$t('Account')" :invalid-feedback="$t('Account is required')" ref="acc">
            <v-select :filterBy="dropFilter" v-model="item.accountID" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="accList"
              :reduce="(opt) => opt.id" label="title" :clearable="false" :disabled="byGrn" ref="acc" :placeholder="$t('Select account')" class="account-select">
              <template #option="option">
                <div class="account-option" v-b-tooltip.hover.top :title="`${option.title} (${option.code})`">
                  <div class="account-name">{{ option.title }}</div>
                  <div class="account-code">{{ option.code }}</div>
                </div>
              </template>
              <template #selected-option="option">
                <div class="account-selected">
                  <div class="account-name-text">{{ option.title }}</div>
                  <div class="account-code-text">{{ option.code }}</div>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="2" class="pr-1 pr-md-0 debit-credit-col">
          <b-form-group :label="$t('Debit')" :invalid-feedback="$t('Debit is required')" ref="debit">
            <b-form-input
              :id="'debit' + ind"
              type="number"
              step="any"
              min="0"
              ref="debit"
              placeholder="0.00"
              v-model="item.debit"
              :disabled="byGrn"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" class="pr-1 pr-md-0 debit-credit-col">
          <b-form-group :label="$t('Credit')" :invalid-feedback="$t('Credit is required')" ref="credit">
            <b-form-input
              type="number"
              step="any"
              min="0"
              placeholder="0.00"
              ref="credit"
              v-model="item.credit"
              :disabled="byGrn"
            />
          </b-form-group>
        </b-col>
        <b-col md="1" class="pr-1 pr-md-0 cheque-col">
          <b-form-group :label="$t('Cheque No')" :invalid-feedback="$t('Cheque No is required')" ref="chq">
            <b-form-input :placeholder="$t('Enter Cheque no')" ref="chq" v-model.trim="item.chequeNo" />
          </b-form-group>
        </b-col>
        <b-col md="2" class="pr-1 pr-md-0 note-col">
          <b-form-group :label="$t('Note')" :invalid-feedback="$t('Note is required')" ref="note">
            <b-form-textarea :placeholder="$t('Enter note')" ref="note" v-model="item.description" rows="2" />
          </b-form-group>
        </b-col>
        <b-col md="1" class="mt-md-2">
          <b-button v-if="ind == myObj.length - 1" @click="AddValue(item, ind + 1)" variant="primary" class="btn-icon rounded-circle mr-50">
            <feather-icon icon="PlusIcon" />
          </b-button>
          <b-button v-if="myObj.length > 1" @click="removeValue(item, ind)" variant="outline-danger" class="btn-icon rounded-circle">
            <feather-icon icon="XIcon" />
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <div class="card-body">
      <b-row>
        <b-col md="3" class="pr-1 pr-md-0"></b-col>
        <b-col md="2" class="pr-1 pr-md-0">
          <h5 class="font-weight-bolder mb-0">Rs. {{ formatLedgerDisplay(totalDebit) }}</h5>
        </b-col>
        <b-col md="2" class="pr-1 pr-md-0">
          <h5 class="font-weight-bolder mb-0">Rs. {{ formatLedgerDisplay(totalCredit) }}</h5>
        </b-col>
      </b-row>
    </div>

    <h3 class="mb-1">{{ $t("Attachments") }}</h3>
    <b-card>
      <div class="d-flex flex-wrap">
        <div class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-1 mb-1"
          style="width: 110px; height: 96px" @click="!mydocloading && $refs.psamplefile.click()">
          <b-spinner v-if="mydocloading" small :label="$t('Loading') + '...'" variant="primary" />
          <feather-icon v-else icon="PlusIcon" size="34" class="text-primary" />
        </div>
        <div class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-1 mb-1 accounting-attach-item"
          style="width: 110px; height: 96px; position: relative; overflow: hidden" v-for="(file, index) in attachList" :key="index" @click="openFile(getAttachUrl(file))">
          <b-avatar size="20" variant="primary" style="position: absolute; top: -5px; right: -5px; z-index: 2">
            <feather-icon icon="XIcon" @click.stop="deleteDocument(index)" />
          </b-avatar>
          <template v-if="isPreviewableAttach(file)">
            <div class="accounting-attach-preview-wrap">
              <b-spinner
                v-if="imageLoading[getAttachUrl(file)]"
                small
                variant="primary"
                class="accounting-attach-spinner"
              />
              <img
                :src="getAttachPreviewUrl(file)"
                :alt="getAttachLabel(file, index)"
                referrerpolicy="no-referrer"
                class="accounting-attach-image"
                v-show="!imageLoading[getAttachUrl(file)]"
                @load="onAttachImageLoad(file)"
                @loadstart="onAttachImageLoadStart(file)"
                @error="handleAttachPreviewError($event, file)"
              />
            </div>
          </template>
          <feather-icon v-else icon="FileTextIcon" size="30" class="text-primary" />
        </div>

        <input type="file" id="psamplefile" hidden ref="psamplefile" multiple @change="PsampleAdd()" accept="image/*,application/pdf" />
      </div>
    </b-card>
    <b-row align-h="center">
      <b-col md="4">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" @click="Add()" :disabled="request || poLoading" block>
          <b-spinner v-if="request" small type="grow" />
          <span v-else> {{ $t("Save") }} </span>
        </b-button>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-1">
      <b-col md="4">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" @click="Add('print')" :disabled="request || poLoading" block>
          <b-spinner v-if="request" small type="grow" />
          <template v-else>
            <feather-icon icon="PrinterIcon" />
            <span> {{ $t("Save & Print") }} </span>
          </template>
        </b-button>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-1" v-if="saveObj.id == 0">
      <b-col md="4">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="warning" @click="Add(true)" :disabled="request || poLoading" block>
          <b-spinner v-if="request" small type="grow" />
          <span v-else>{{ $t("Request For Approval") }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BBadge,
  BTable,
  BFormInput,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BForm,
  BSpinner,
  BAvatar,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import {
  buildUploadedAttachment,
  getDocumentDisplayName,
  getDriveImagePreviewCandidates,
  getDocPreviewUrl as resolveDocPreviewUrl,
  getDocUrl as resolveDocUrl,
  handleDrivePreviewError,
  isPreviewableDoc as checkPreviewableDoc,
  parseDocUrls,
  serializeDocUrls,
  uploadToMySkool,
} from "@/utils/gdriveUpload";
import roleCoaAccessMixin from "@/mixins/roleCoaAccessMixin";

export default {
  mixins: [roleCoaAccessMixin],
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BTable,
    BFormInput,
    BFormTextarea,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BSpinner,
    BAvatar,
    flatPickr,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  // mounted() {
  //   window.addEventListener("keydown", this.handleEvent);
  // },
  // beforeDestroy() {
  //   window.removeEventListener("keydown", this.handleEvent);
  // },
  async created() {
    let right = this.$store.state.rights["journal"];

    if (!right) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = right;

      this.$route.params.id = parseInt(this.$route.params.id);
      if (this.$route.params.id > 0 && right.edit) {
        this.saveObj = this.$route.params.data.entry;
        this.myObj = this.$route.params.data.details;

        this.attachList = parseDocUrls(this.saveObj.attachments);

        this.LoadAccounts();
        this.loadDeps();
        this.loadVtSettings();
        this.LoadSettings();
        this.LoadSettingsAll();
        this.loadVendors();
      } else if (this.$route.params.id == 0 && right.add) {
        this.LoadAccounts();
        this.loadDeps();
        this.loadVtSettings();
        this.LoadSettings();
        this.LoadSettingsAll();
        this.loadVendors();
        this.setCurrentDate();
      } else {
        this.$router.replace({
          name: "misc-not-authorized",
        });
      }

      if (this.reportDomain == "myskoolelixir") {
        this.typeOptions.push({ text: "INV", value: "INV" });
      }
    }
  },
  computed: {
    totalCredit() {
      const raw = this.myObj.reduce((sum, el) => {
        const credit = parseFloat(el.credit) || 0;
        return sum + credit;
      }, 0);
      return Math.round(raw * 100) / 100;
    },
    totalDebit() {
      const raw = this.myObj.reduce((sum, el) => {
        const debit = parseFloat(el.debit) || 0;
        return sum + debit;
      }, 0);
      return Math.round(raw * 100) / 100;
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      rights: {},
      mydocloading: false,
      attachList: [],
      imageLoading: {},
      attachPreviewFailed: {},
      vendorObj: {
        id: 0,
        name: "",
        mobile_number: "",
        campusID: this.$store.state.userData.cId,
      },
      check: 1,
      request: false,
      visibility2: false,
      dataLoading: false,
      visibility: false,
      visibilityVendor: false,
      searchID: "",
      vendorFields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      typeOptions: [
        { text: "CPV", value: "cpv" },
        { text: "BPV", value: "bpv" },
        { text: "CRV", value: "crv" },
        { text: "BRV", value: "brv" },
        { text: "JV", value: "jv" },
      ],
      accList: [],
      depList: [],
      vendorList: [],
      supplierList: [],
      myObj: [
        {
          id: 0,
          journalEntryID: 0,
          accountID: 0,
          debit: 0,
          credit: 0,
          chequeNo: "",
          description: "",
          campusID: this.$store.state.userData.cId,
        },
      ],
      saveObj: {
        id: 0,
        chequeTitle: "",
        voucherNum: 0,
        voucherType: this.$store.state.vType,
        date: new Date().toJSON(),
        description: "",
        status: "active",
        departmentID: 1,
        vendorID: 0,
        userID: this.$store.state.userData.userID,
        campusID: this.$store.state.userData.cId,
      },
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      depFields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      saving: false,
      accIcon: "",
      vtData: [],
      vtSaveData: [],
      autoEntry: null,
      multiDep: null,
      reviewObj: null,
      accObj: null,
      poLoading: false,
      byGrn: false,
      idList: null,
      grnObj: null,
      supplierObj: null,
      supplierGrns: [],
      grnFields: [
        { label: "ID", key: "id" },
        { label: "quotation ID", key: "quotationID" },
        { label: "Date", key: "date" },
        { label: "Delivery Charges", key: "deliveryCharges" },
        { label: "Total", key: "total" },
        // { label: "Note", key: "note" },
      ],
      selectedList: [],
    };
  },

  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    isPreviewableAttach(file) {
      const url = this.getAttachUrl(file);
      if (this.attachPreviewFailed[url]) return false;
      return checkPreviewableDoc(file);
    },
    getAttachPreviewUrl(file) {
      return resolveDocPreviewUrl(file);
    },
    getAttachUrl(file) {
      return resolveDocUrl(file);
    },
    getAttachLabel(file, index) {
      return getDocumentDisplayName(this.getAttachUrl(file), index);
    },
    onAttachImageLoadStart(file) {
      this.$set(this.imageLoading, this.getAttachUrl(file), true);
    },
    onAttachImageLoad(file) {
      this.$set(this.imageLoading, this.getAttachUrl(file), false);
    },
    handleAttachPreviewError(event, file) {
      const url = this.getAttachUrl(file);
      handleDrivePreviewError(event, url, "image");
      const img = event?.target;
      const tried = img?.getAttribute("data-preview-index");
      const nextIndex = tried === null ? 1 : Number(tried) + 1;
      const candidates = getDriveImagePreviewCandidates(url);
      if (!candidates[nextIndex]) {
        this.$set(this.attachPreviewFailed, url, true);
      }
    },
    async setCurrentDate() {
      var obj = {
        url: this.$store.state.domain + "Fees/GetDate",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      // console.log(res);
      if (res && !Array.isArray(res)) {
        this.saveObj.date = res;
      } else {
        this.saveObj.date = new Date().toJSON();
      }
    },
    async checkGrnID() {
      let x = parseInt(this.searchID);
      if (isNaN(x) || x <= 0) {
        this.$bvToast.toast(this.$t("Please enter the GRN ID."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      this.searchID = x;
      this.poLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "JournalEntry/LoadGrn?db=" +
          this.$store.state.userData.db +
          "&grnID=" +
          this.searchID,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (res?.grn && res.data.length > 0) {
        this.byGrn = true;
        this.grnObj = res.grn;
        this.supplierObj = null;
        this.selectedList = [];
        this.myObj = res.data.map((el) => ({
          id: 0,
          journalEntryID: this.saveObj.id,
          accountID: el.pd.accountID,
          debit: el.gd.totalPrice,
          credit: 0,
          chequeNo: "",
          description: el.pd.name,
          campusID: this.$store.state.userData.cId,
        }));
        if (this.idList) {
          if (res.grn.deliveryCharges > 0 && this.idList.value) {
            this.myObj.push({
              id: 0,
              journalEntryID: this.saveObj.id,
              accountID: parseInt(this.idList.value),
              debit: res.grn.deliveryCharges,
              credit: 0,
              chequeNo: "",
              description: "Delivery Charges",
              campusID: this.$store.state.userData.cId,
            });
          }
          if (this.idList.valueNumber) {
            this.myObj.push({
              id: 0,
              journalEntryID: this.saveObj.id,
              accountID: this.idList.valueNumber,
              debit: 0,
              credit: res.grn.total,
              chequeNo: "",
              description: "Uninvoiced",
              campusID: this.$store.state.userData.cId,
            });
          }
        }
      } else {
        this.$bvToast.toast(this.$t("No records found"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.byGrn = false;
        this.grnObj = null;
        this.supplierObj = null;
        this.selectedList = [];
        this.myObj = [
          {
            id: 0,
            journalEntryID: this.saveObj.id,
            accountID: 0,
            debit: 0,
            credit: 0,
            chequeNo: "",
            description: "",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
      this.poLoading = false;
    },
    async getGrn() {
      // console.log(this.supplierObj);
      this.grnObj = null;
      this.byGrn = false;
      this.selectedList = [];
      if (this.supplierObj) {
        this.poLoading = true;
        var obj = {
          url:
            this.$store.state.domain +
            "goodsReceivingNote/LoadByVendor?db=" +
            this.$store.state.userData.db +
            "&vendorID=" +
            this.supplierObj.id,
          token: this.$store.state.userData.token,
        };
        this.supplierGrns = await this.get(obj);
        // console.log(this.supplierGrns);
        if (this.supplierGrns.length > 0) {
          this.$bvModal.show("modal-grn");
        } else {
          this.$bvToast.toast(this.$t("No records found"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
        this.poLoading = false;
      } else {
        this.myObj = [
          {
            id: 0,
            journalEntryID: this.saveObj.id,
            accountID: 0,
            debit: 0,
            credit: 0,
            chequeNo: "",
            description: "",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
    },
    selectGrn(rows) {
      this.selectedList = rows;
      // console.log(this.selectedList);
    },
    confirmGrn() {
      const gTotal = this.selectedList.reduce(
        (acc, item) => acc + item.total,
        0
      );
      if (this.idList) {
        this.myObj = [
          {
            id: 0,
            journalEntryID: this.saveObj.id,
            accountID: this.idList.valueNumber,
            debit: gTotal,
            credit: 0,
            chequeNo: "",
            description: "Uninvoiced",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
      this.myObj.push({
        id: 0,
        journalEntryID: this.saveObj.id,
        accountID: this.supplierObj.accountID,
        debit: 0,
        credit: gTotal,
        chequeNo: "",
        description: this.supplierObj.name,
        campusID: this.$store.state.userData.cId,
      });
      this.$bvModal.hide("modal-grn");
    },
    async PsampleAdd() {
      if (this.$refs.psamplefile.files.length !== 0) {
        this.mydocloading = true;
        const fileList = Array.from(this.$refs.psamplefile.files);
        try {
          const uploaded = await uploadToMySkool(fileList);
          uploaded.forEach((el, index) => {
            const sourceFile = fileList[index];
            const attachment = buildUploadedAttachment({
              ...el,
              mimetype: el.mimetype || sourceFile?.type,
              originalname: el.originalname || sourceFile?.name,
            });
            this.attachList.push(attachment);
          });
          this.saveObj.attachments = serializeDocUrls(this.attachList);
        } catch (error) {
          console.log(error);
        } finally {
          this.mydocloading = false;
          if (this.$refs.psamplefile) this.$refs.psamplefile.value = "";
        }
      }
    },
    deleteDocument(index) {
      this.attachList.splice(index, 1);
      this.saveObj.attachments = serializeDocUrls(this.attachList);
    },
    openFile(url) {
      window.open(resolveDocUrl(url), "_blank");
    },
    handleEvent(event) {
      // console.log(event);
      if (event.ctrlKey && event.keyCode === 83) {
        event.preventDefault();
        if (this.check == 1) {
          this.check = 0;
          this.Add();
        }
      }
    },
    setVT() {
      this.$store.commit("setVType", this.saveObj.voucherType);
    },

    async LoadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["accounts_multi_department", "accounts_grn"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.multiDep = res.find((el) => el.key == "accounts_multi_department");
      this.idList = res.find((el) => el.key == "accounts_grn");
      // console.log(this.multiDep);
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["inventory_account", "journal_entry_review"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.accObj = res.find((el) => el.key == "inventory_account");
      this.reviewObj = res.find((el) => el.key == "journal_entry_review");

      if (this.accObj?.valueBool) {
        this.LoadSupplier();
      }
    },
    async LoadSupplier() {
      var obj = {
        url:
          this.$store.state.domain +
          "posSupplier?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.supplierList = await this.get(obj);
    },

    async loadVtSettings() {
      var obj = {
        url:
          this.$store.state.domain +
          "VoucherAccounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.vtData = await this.get(obj);
      // console.log(this.vtData);
    },
    openVtSettings() {
      this.visibility2 = true;
      if (this.vtData.length == 0) {
        this.vtSaveData = [
          {
            id: 0,
            voucherType: "CPV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            voucherType: "BPV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            voucherType: "CRV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            voucherType: "BRV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
        ];
      } else this.vtSaveData = [...this.vtData];
    },
    setAutoAccount() {
      let obj = this.vtData.find(
        (el) => el.voucherType == this.saveObj.voucherType
      );
      // console.log(obj);
      if (
        obj &&
        obj.accountID != 0 &&
        obj.accountID != null &&
        obj.accountID != ""
      ) {
        this.autoEntry = {
          id: 0,
          journalEntryID: this.saveObj.id,
          accountID: obj.accountID,
          debit: 0,
          credit: 0,
          chequeNo: "",
          description: "",
          campusID: this.$store.state.userData.cId,
        };

        if (
          this.saveObj.voucherType == "CPV" ||
          this.saveObj.voucherType == "BPV"
        ) {
          this.autoEntry.credit =
            Math.round((this.totalDebit - this.totalCredit) * 100) / 100;
        } else if (
          this.saveObj.voucherType == "CRV" ||
          this.saveObj.voucherType == "BRV"
        ) {
          this.autoEntry.debit =
            Math.round((this.totalCredit - this.totalDebit) * 100) / 100;
        }
        // console.log(this.autoEntry);
      } else this.autoEntry = null;
    },

    async saveVtSettings() {
      this.saving = true;
      this.vtSaveData.forEach((el) => {
        if (el.accountID == null || el.accountID == "") el.accountID = 0;
      });
      // console.log(this.vtSaveData);
      var status = await this.post({
        url:
          this.$store.state.domain +
          "VoucherAccounts/SaveData?db=" +
          this.$store.state.userData.db,
        body: this.vtSaveData,
        message: "Setting saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.saving = false;
      if (status) {
        this.loadVtSettings();
        this.visibility2 = false;
      }
    },

    openDep() {
      this.accIcon = "PlusIcon";
      this.visibility = true;
      this.depObj = {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["dep_name"];
      elem.state = undefined;
    },
    openVendor() {
      this.accIcon = "PlusIcon";
      this.visibilityVendor = true;
      this.vendorObj = {
        id: 0,
        name: "",
        mobile_number: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["vendor_name"];
      elem.state = undefined;
    },
    CheckName() {
      var elem = this.$refs["dep_name"];
      if (this.depObj.name.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckVendorName() {
      var elem = this.$refs["vendor_name"];
      if (this.vendorObj.name.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async addDep() {
      if (this.CheckName() == true) {
        this.saving = true;
        // console.log(this.depObj);
        if (this.depObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "AccountsDepartment?db=" +
              this.$store.state.userData.db,
            body: this.depObj,
            message: "Department added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "AccountsDepartment/" +
              this.depObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Department updated successfully.",
            context: this,
            body: this.depObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.loadDeps();
          var elem = this.$refs["dep_name"];
          elem.state = undefined;
          this.accIcon = "PlusIcon";
          this.depObj = {
            id: 0,
            name: "",
            campusID: this.$store.state.userData.cId,
          };
        }
        this.saving = false;
      }
    },
    async Edit(item) {
      this.depObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["dep_name"];
      elem.state = undefined;
      // console.log(this.depObj);
    },

    async Delete(id) {
      // console.log(id);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "AccountsDepartment/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Department deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadDeps();
      }
    },
    async addVendor() {
      if (this.CheckVendorName() == true) {
        this.saving = true;
        // console.log(this.depObj);
        if (this.vendorObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Vendors?db=" +
              this.$store.state.userData.db,
            body: this.vendorObj,
            message: "Vendor added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "Vendors/" +
              this.vendorObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Vendor updated successfully.",
            context: this,
            body: this.vendorObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.loadVendors();
          var elem = this.$refs["vendor_name"];
          elem.state = undefined;
          this.accIcon = "PlusIcon";
          this.vendorObj = {
            id: 0,
            name: "",
            mobile_number: "",
            campusID: this.$store.state.userData.cId,
          };
        }
        this.saving = false;
      }
    },
    async EditVendor(item) {
      //console.log(item);
      this.vendorObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["vendor_name"];
      elem.state = undefined;
    },
    async DeleteVendor(id) {
      // console.log(id);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Vendors/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Vendor deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadVendors();
      }
    },
    dropFilter(opt, label, search) {
      // console.log(opt, label, search);
      let st = search.toLowerCase();
      return (
        (opt.title && opt.title.toLowerCase().match(st)) ||
        (opt.code && opt.code.toLowerCase().match(st))
      );
    },
    AddValue(item, ind) {
      if (
        item.accountID != 0 &&
        // item.chequeNo != "" &&
        item.debit !== "" &&
        item.credit !== ""
      ) {
        this.myObj.push({
          id: 0,
          journalEntryID: this.saveObj.id,
          accountID: 0,
          debit: 0,
          credit: 0,
          chequeNo: "",
          description: "",
          campusID: this.$store.state.userData.cId,
        });
        // console.log(this.myObj);
        setTimeout(() => {
          let elem = document.getElementById("debit" + ind);
          elem.focus();
          elem.select();
        }, 100);
      }
    },
    async removeValue(item, ind) {
      if (item.id == 0) {
        this.myObj.splice(ind, 1);
        // console.log(this.myObj);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "JournalEntry/DeleteEntry?cID=" +
            this.$store.state.userData.cId +
            "&db=" +
            this.$store.state.userData.db +
            "&detailID=" +
            item.id,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.myObj.splice(ind, 1);
        // console.log(this.myObj);
      }
    },

    /** Parse amount for debit/credit (supports decimals); strip commas; round to 2 dp for API. */
    normalizeLedgerAmount(value) {
      if (value === "" || value === null || value === undefined) return 0;
      const n = parseFloat(String(value).replace(/,/g, ""));
      if (!Number.isFinite(n) || n < 0) return 0;
      return Math.round(n * 100) / 100;
    },

    formatLedgerDisplay(num) {
      if (num !== 0 && !num) return "0.00";
      return parseFloat(num).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    CheckValues() {
      let state = true;
      this.myObj.forEach((el) => {
        el.debit = this.normalizeLedgerAmount(el.debit);
        el.credit = this.normalizeLedgerAmount(el.credit);
        if (
          el.accountID == 0 ||
          !Number.isFinite(el.credit) ||
          !Number.isFinite(el.debit)
        ) {
          state = false;
        }
      });
      return state;
    },
    CheckVType() {
      var elem = this.$refs["vt"];
      if (this.saveObj.voucherType.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckVNum() {
      var re = /^[0-9]+$/;
      var elem = this.$refs["vNo"];
      let x = parseInt(this.saveObj.voucherNum);
      if (!re.test(this.saveObj.voucherNum) || isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDep() {
      var elem = this.$refs["dep"];
      if (this.saveObj.departmentID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    async Add(val) {
      this.CheckVType();
      //this.CheckVNum();
      // this.CheckDep();
      if (
        this.CheckVType() == false ||
        // this.CheckDep() == false ||
        this.CheckValues() == false
      ) {
        this.check = 1;
        this.$bvToast.toast(this.$t("Please enter the details correctly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.saveObj.id == 0 && this.saveObj.voucherType != "JV") {
          this.setAutoAccount();
          if (this.autoEntry != null) {
            this.myObj.push(this.autoEntry);
          }
        }
        // this.myObj.forEach((element) => {
        //   element.journalEntryID = 0;
        // });
        let mybody = {
          entry: this.saveObj,
          details: this.myObj,
        };
        const balDiff = Math.abs(this.totalDebit - this.totalCredit);
        if (balDiff > 0.005) {
          this.check = 1;
          this.$bvToast.toast(this.$t("Debit and Credit must be equal!"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          this.saveObj.voucherNum = parseInt(this.saveObj.voucherNum);
          // console.log("obj:", this.saveObj, this.myObj);
          // console.log(this.totalDebit, this.totalCredit);
          if (val === true) {
            this.saveObj.status = this.reviewObj?.valueBool
              ? "under review"
              : "pending";
          }
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "JournalEntry/Save?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: mybody,
            message: "Journal saved successfully.",
            context: this,
            token: this.$store.state.userData.token,
            returnData: true,
          });
          this.request = false;
          this.autoEntry = null;
          // console.log(status);

          if (status) {
            if (val == "print") {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/PrintEntryVoucher?entryID=` +
                status.entry.id +
                "&dbb=" +
                this.$store.state.userData.db +
                "&cID=" +
                this.$store.state.userData.cId;

              window.open(url, "_blank");
            }
            if (this.grnObj) {
              this.grnObj.journalEntryID = 0;
              let pObj = [this.grnObj];
              this.updateGrn(pObj);
            } else if (this.supplierObj && this.selectedList.length > 0) {
              this.selectedList.forEach((el) => {
                el.journalEntryID = status.entry.id;
              });
              this.updateGrn(this.selectedList);
            }

            // remain on page on entry add 
            if (this.reportDomain == "myskoolaba" && this.saveObj.id == 0) {
              this.saveObj = status.entry;
              this.myObj = status.details;
              // console.log(this.saveObj, this.myObj);
            }
            else this.$router.go(-1);
          }
          this.check = 1;
        }
      }
    },
    async updateGrn(items) {
      var status = await this.post({
        url:
          this.$store.state.domain +
          "goodsReceivingNote/updateData?db=" +
          this.$store.state.userData.db,
        body: items,
        subjects: true,
        context: this,
        token: this.$store.state.userData.token,
      });
    },

    hideSideBar() {
      this.visibility = false;
    },
    hideSideBarVendor() {
      this.visibilityVendor = false;
    },

    async LoadAccounts() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const raw = await this.get(obj);
      const list = this.normalizeAccountsResponse(raw);
      this.accList = this.filterAccountsByRole(list);
      // console.log("acc", this.accList);
      this.dataLoading = false;
    },
    async loadDeps() {
      var obj = {
        url:
          this.$store.state.domain +
          "AccountsDepartment?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.depList = await this.get(obj);
      // console.log("dep", this.depList);
    },
    async loadVendors() {
      var obj = {
        url:
          this.$store.state.domain +
          "Vendors?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      var vData = await this.get(obj);

      // this.vendorList.push({
      //   id: 0,
      //   name: "None",
      //   mobile_number: "",
      //   campusID: this.$store.state.userData.cId,
      // });

      vData.forEach((element) => {
        this.vendorList.push({
          id: element.id,
          name: element.name,
          mobile_number: element.mobile_number,
          campusID: element.campusID,
        });
      });
      // console.log("dep", this.depList);
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.accounting-attach-preview-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.accounting-attach-spinner {
  position: absolute;
}
.accounting-attach-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.357rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.border-dashed {
  border: 1px solid var(--primary);
  border-style: dashed;
}

.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.card {
  transition: 0.4s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.account-select {
  min-width: 100%;
}

.account-select ::v-deep .vs__dropdown-menu {
  min-width: 350px;
  max-width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar {
  width: 8px;
}

.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.account-option {
  padding: 4px 0;
  cursor: pointer;
}

.account-option:hover {
  background-color: transparent;
}

.account-select ::v-deep .vs__dropdown-option--highlight {
  background-color: #fff !important;
  color: #5e5873 !important;
}

.account-select ::v-deep .vs__dropdown-option--selected {
  background-color: #f8f8f8 !important;
  color: #5e5873 !important;
}

.account-select ::v-deep .vs__dropdown-option:hover {
  background-color: #f0f0f0 !important;
  color: #5e5873 !important;
}

.account-option {
  padding: 4px 0;
}

.account-name {
  font-weight: 500;
  font-size: 14px;
  color: #5e5873;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.account-code {
  font-size: 12px;
  color: #6e6b7b;
  margin-top: 2px;
  line-height: 1.3;
}

.account-selected {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2px;
  line-height: 1.3;
  max-width: 100%;
}

.account-name-text {
  font-weight: 500;
  font-size: 13px;
  color: #5e5873;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  overflow-x: auto;
  overflow-y: hidden;
  line-height: 1.4;
  cursor: pointer;
  max-width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.account-name-text::-webkit-scrollbar {
  height: 4px;
}

.account-name-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.account-name-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.account-name-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.account-code-text {
  font-size: 11px;
  color: #6e6b7b;
  white-space: normal;
  overflow-x: auto;
  overflow-y: hidden;
  line-height: 1.2;
  cursor: pointer;
  max-width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.account-code-text::-webkit-scrollbar {
  height: 4px;
}

.account-code-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.account-code-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.account-code-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.account-select ::v-deep .vs__selected {
  white-space: normal;
  overflow-x: auto;
  overflow-y: hidden;
  height: auto;
  min-height: 38px;
  padding: 4px 8px;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.account-select ::v-deep .vs__selected::-webkit-scrollbar {
  height: 4px;
}

.account-select ::v-deep .vs__selected::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.account-select ::v-deep .vs__selected::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.account-select ::v-deep .vs__selected::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

@media (min-width: 768px) {
  .account-col {
    min-width: 280px;
    flex: 0 0 25%;
  }

  .debit-credit-col {
    min-width: 150px;
    flex: 0 0 16.666%;
  }

  .cheque-col {
    min-width: 120px;
    flex: 0 0 8.333%;
  }

  .note-col {
    min-width: 180px;
    flex: 0 0 16.666%;
  }
}
</style>
